<dr-header></dr-header>
<main>
	<router-outlet></router-outlet>
</main>
